import { IRuntimeConfiguration, OEConnectEnvironment } from '../runtime-configuration';

declare let OEConnectConfig;

class RuntimeConfiguration extends IRuntimeConfiguration {
    getApiRoot(): string {
        return OEConnectConfig.apiRoot;
    }

    getAppDomain(): string {
        const postfix = 'oe-central';

        // @ts-ignore
        switch (window.OEConnectConfig.env) {
            case OEConnectEnvironment.Prod:
                return postfix;
            case OEConnectEnvironment.Stage:
                return 'stage-' + postfix;
            default:
                return 'dev-' + postfix;
        }
    }

    getBaseUrl(): string {
        return OEConnectConfig.baseUrl;
    }

    getEnv(): OEConnectEnvironment {
        return OEConnectConfig.env;
    }

    getFusionAuthDomain(): string {
        // @ts-ignore
        switch (window.OEConnectConfig.env) {
            case OEConnectEnvironment.Prod:
                return 'auth.oe-central';
            case OEConnectEnvironment.Stage:
                return 'auth.stage-oe-central';
            default:
                return 'auth.dev-oe-central';
        }
    }

    useCookieAuth(): boolean {
        // return this.getEnv() !== OEConnectEnvironment.Prod;
        return true;
    }
}

export { RuntimeConfiguration };
